import { inject, Injectable } from '@angular/core';
import { FaultRecommendationsStore, TroubleshootingStore } from '@shared/state';
import { FaultRecommendationsStateModel, FetchFaultCatalogParams, FetchResolvedFaultsParams } from '@shared/models';
import { QueryParameterService } from '@shared/services';

export const SESSION_STORAGE_KEY = 'faultRecommendationsFilters';
@Injectable({
  providedIn: 'root',
})
export class FaultRecommendationsService {
  protected readonly queryParametersService = inject(QueryParameterService);
  private readonly faultRecommendationsStore = inject(FaultRecommendationsStore);
  private readonly troubleshootingStore = inject(TroubleshootingStore);

  init(params: FaultRecommendationsStateModel) {
    this.updateStateAndQueryParams(params);
    this.fetchResolvedFaults(params as FetchResolvedFaultsParams);
    this.fetchFaultCatalog(params);

    if (params?.fault) {
      this.fetchRecommendations(params.fault);
    }
  }

  private updateStateAndQueryParams(params: FaultRecommendationsStateModel) {
    this.faultRecommendationsStore.setState(params);
    void this.queryParametersService.setQueryParams({ key: SESSION_STORAGE_KEY, queryParams: params });
  }

  private fetchRecommendations(fault: number) {
    this.troubleshootingStore.fetchRecommendationsByFaultCode(fault);
  }

  private fetchResolvedFaults({ page, pageSize }: FetchResolvedFaultsParams) {
    this.faultRecommendationsStore.fetchResolvedFaults({ page, pageSize });
  }

  private fetchFaultCatalog(params: FetchFaultCatalogParams) {
    this.faultRecommendationsStore.fetchFaultCatalog(params);
  }

  setFaultCode(fault: number): void {
    this.updateStateAndQueryParams({ fault });
    this.fetchRecommendations(fault);
  }

  setWithoutRecommendations(withoutRecommendations?: boolean): void {
    this.updateStateAndQueryParams({ withoutRecommendations, fault: undefined });
    this.fetchFaultCatalog({ withoutRecommendations });
  }

  updatePagination(params: FaultRecommendationsStateModel) {
    this.updateStateAndQueryParams(params);
    this.fetchResolvedFaults(params as FetchResolvedFaultsParams);
  }
}
